import {
  ProductPackageTotalIntroPricePayloadType,
  ProductionPackageTotalIntroAPIResponseType,
} from 'types/productPackage';
import { api } from 'utils/api';

const getTotalIntroductionPrice = async (
  payload: ProductPackageTotalIntroPricePayloadType,
): Promise<ProductionPackageTotalIntroAPIResponseType> => {
  const response = await api.packageControllerGetPriceByQuantityV1(payload, {});

  const responseData =
    (response.data as unknown as ProductionPackageTotalIntroAPIResponseType) || response.error;

  return responseData;
};

export default getTotalIntroductionPrice;
